// Mensajes de los errores de inscribir_grupo que el club tiene que entender. La base manda el
// HINT; el texto es de la pantalla. Lo que no se reconoce se muestra como hoy.

// Contrato B3 de la pieza 2b. Sin boton: al titular la puerta legal ya lo detiene hasta que
// acepta el convenio 1.1, asi que quien llega aqui no puede aceptarlo.
export const MENSAJE_CONDICIONES_TORNEO =
  'Para jugar torneos, tu club debe aceptar el convenio 1.1. Lo acepta el titular de tu club al entrar a MYKLUBB.'

export const mensajeErrorInscripcion = (err) => {
  if (err?.hint === 'CONDICIONES_TORNEO_PENDIENTES') return MENSAJE_CONDICIONES_TORNEO
  return err?.message || 'No se pudo inscribir el grupo.'
}
